const changeBodyBackground = () => {

    if(document.body.style.background !== "rgb(32, 30, 30)"){
      document.body.style.background="rgb(32, 30, 30)"
      document.getElementById("containerProfileDetails").style.color="rgb(112, 126, 111)"

    } else {
      document.body.style.background = "linear-gradient(40deg,rgba(9,102,121,1) 0%, rgba(9,102,121,1) 35%)"
      document.getElementById("containerProfileDetails").style.color="black"
      
    }
}

export default changeBodyBackground;